var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-arrange-statistics" },
    [
      _vm.isGroupFun
        ? _c("yxtbiz-group-org-select", {
            staticClass: "mr12",
            attrs: { placeholder: _vm.$t("pc_ote_lbl_group_select_orgId") },
            on: {
              change: function ($event) {
                return _vm.setSelectedGroup($event, _vm.params, _vm.getDetail)
              },
            },
            model: {
              value: _vm.selectedGroup,
              callback: function ($$v) {
                _vm.selectedGroup = $$v
              },
              expression: "selectedGroup",
            },
          })
        : _vm._e(),
      !_vm.isLoopExamAll
        ? _c(
            "div",
            { staticClass: "yxtbiz-arrange-statistics__row" },
            [
              _c(
                "yxt-row",
                { attrs: { gutter: 12, type: "flex" } },
                [
                  _vm.showArrangeCount
                    ? [
                        _c("yxt-col", { attrs: { span: 6 } }, [
                          _c(
                            "div",
                            { staticClass: "yxtbiz-arrange-statistics__block" },
                            [
                              _c("yxt-row", [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "lh22 font-size-14 mt0 mb0 bold-400 flex-align-center",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("pc_ote_lbl_attendcount")
                                        ) +
                                        "\n                "
                                    ),
                                    _c(
                                      "yxt-tooltip",
                                      {
                                        attrs: {
                                          content: _vm.$t(
                                            "pc_ote_lbl_attendcounttip" /** 累计参加过考试的所有人数 */
                                          ),
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("yxt-svg", {
                                          staticClass: "ml4 color-gray-7 hand",
                                          attrs: {
                                            "icon-class": "question-cirlce-o",
                                            width: "14px",
                                            height: "15px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                "yxt-row",
                                { staticClass: "mt8 font-size-28 lh36" },
                                [_vm._v(_vm._s(_vm.baseInfo.answerQty || 0))]
                              ),
                              _c("yxt-divider", {
                                staticClass:
                                  "yxtbiz-arrange-statistics__block-line opacity-5",
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "lh20 font-size-12 flex flex-wrap",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-in-flex flex-shrink-0 minw-p-50 flex-g-1 pr8 mb4",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "mr8 color-gray-7" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("pc_ote_lbl_absentcount")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(_vm._s(_vm.baseInfo.missQty || 0)),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-in-flex flex-shrink-0 mb4",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "mr8 color-gray-7" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("pc_ote_lbl_attendrate")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        _vm._s(
                                          parseFloat(
                                            (
                                              (_vm.baseInfo.answerQtyRate ||
                                                0) * 100
                                            ).toFixed(1)
                                          )
                                        ) + "%"
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-in-flex flex-shrink-0 minw-p-50",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "mr8 color-gray-7" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("pc_ote_lbl_arrangecount")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        _vm._s(_vm.baseInfo.totalQty || 0)
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("yxt-col", { attrs: { span: 6 } }, [
                          _c(
                            "div",
                            { staticClass: "yxtbiz-arrange-statistics__block" },
                            [
                              _c("yxt-row", [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "lh22 font-size-14 mt0 mb0 bold-400 flex-align-center",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("pc_ote_lbl_attendtimes")
                                        ) +
                                        "\n                "
                                    ),
                                    _c(
                                      "yxt-tooltip",
                                      {
                                        attrs: {
                                          content:
                                            _vm.$t(
                                              "pc_ote_lbl_attendtimesrate"
                                            ) +
                                            "=" +
                                            _vm.$t("pc_ote_lbl_attendtimes") +
                                            "/" +
                                            _vm.$t("pc_ote_lbl_arrangecount"),
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("yxt-svg", {
                                          staticClass: "ml4 color-gray-7 hand",
                                          attrs: {
                                            "icon-class": "question-cirlce-o",
                                            width: "14px",
                                            height: "15px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                "yxt-row",
                                { staticClass: "mt8 font-size-28 lh36" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.baseInfo.answerPersonTime || 0)
                                  ),
                                ]
                              ),
                              _c("yxt-divider", {
                                staticClass:
                                  "yxtbiz-arrange-statistics__block-line opacity-5",
                              }),
                              _c(
                                "yxt-row",
                                { staticClass: "font-size-12 lh20" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "color-gray-7 mr8" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("pc_ote_lbl_attendtimesrate")
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        parseFloat(
                                          (
                                            (_vm.baseInfo
                                              .answerPersonTimeRate || 0) * 100
                                          ).toFixed(1)
                                        )
                                      ) + "%"
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "yxt-row",
                                { staticClass: "font-size-12 lh20 mt4" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "color-gray-7 mr8" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("pc_ote_lbl_arrangecount")
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.baseInfo.totalQty || 0)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    : [
                        _c("yxt-col", { attrs: { span: 6 } }, [
                          _c(
                            "div",
                            { staticClass: "yxtbiz-arrange-statistics__block" },
                            [
                              _c("yxt-row", [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "lh22 font-size-14 mt0 mb0 bold-400 flex-align-center",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("pc_ote_lbl_attendcount")) +
                                        "\n                "
                                    ),
                                    _c(
                                      "yxt-tooltip",
                                      {
                                        attrs: {
                                          content: _vm.$t(
                                            "pc_ote_lbl_attendcounttip" /** 累计参加过考试的所有人数 */
                                          ),
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("yxt-svg", {
                                          staticClass: "ml4 color-gray-7 hand",
                                          attrs: {
                                            "icon-class": "question-cirlce-o",
                                            width: "14px",
                                            height: "15px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                "yxt-row",
                                { staticClass: "mt8 font-size-28 lh36" },
                                [_vm._v(_vm._s(_vm.baseInfo.answerQty || 0))]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("yxt-col", { attrs: { span: 6 } }, [
                          _c(
                            "div",
                            { staticClass: "yxtbiz-arrange-statistics__block" },
                            [
                              _c("yxt-row", [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "lh22 font-size-14 mt0 mb0 bold-400 flex-align-center",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("pc_ote_lbl_attendtimes")
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "yxt-row",
                                { staticClass: "mt8 font-size-28 lh36" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.baseInfo.answerPersonTime || 0)
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                  _c("yxt-col", { attrs: { span: 6 } }, [
                    _c(
                      "div",
                      { staticClass: "yxtbiz-arrange-statistics__block" },
                      [
                        _c("div", { staticClass: "pr zindex2" }, [
                          _c(
                            "h3",
                            {
                              staticClass:
                                "lh22 font-size-14 mt0 mb0 bold-400 flex-align-center",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("pc_ote_lbl_passingrate")) +
                                  "\n              "
                              ),
                              _c(
                                "yxt-tooltip",
                                {
                                  attrs: {
                                    content:
                                      _vm.$t("pc_ote_lbl_passingrate") +
                                      "=" +
                                      _vm.$t("pc_ote_lbl_passingpersons") +
                                      "/" +
                                      _vm.$t("pc_ote_lbl_attendcount"),
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("yxt-svg", {
                                    staticClass: "ml4 color-gray-7 hand",
                                    attrs: {
                                      "icon-class": "question-cirlce-o",
                                      width: "14px",
                                      height: "15px",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        !_vm.isLoading
                          ? _c(
                              "div",
                              { staticClass: "pr zindex1" },
                              [
                                _c("OteGuage", {
                                  attrs: {
                                    rate: _vm.baseInfo.passRate || 0,
                                    rateName: _vm.$t("pc_ote_lbl_passingrate"),
                                    uniqueKey: "1",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "lh20 font-size-12 flex flex-wrap mt8",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "d-in-flex maxw-p-100 flex-shrink-0 flex-g-1 pr8 mb4",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "mr8 color-gray-7" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "pc_ote_lbl_passingpersons" /** 通过人数 */
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(_vm._s(_vm.baseInfo.passQty || 0)),
                              ]
                            ),
                            _c(
                              "span",
                              { staticClass: "d-in-flex flex-shrink-0 mb4" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "mr8 color-gray-7" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("pc_ote_lbl_oncepassrate"))
                                    ),
                                  ]
                                ),
                                _vm._v(_vm._s(_vm.baseInfo.oncePassRate) + "%"),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _c("yxt-col", { attrs: { span: 6 } }, [
                    _c(
                      "div",
                      { staticClass: "yxtbiz-arrange-statistics__block" },
                      [
                        _c("yxt-row", { staticClass: "pr zindex2" }, [
                          _c(
                            "h3",
                            {
                              staticClass:
                                "lh22 font-size-14 mt0 mb0 bold-400 flex-align-center",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("pc_ote_lbl_excellentrate")) +
                                  "\n              "
                              ),
                              _c(
                                "yxt-tooltip",
                                {
                                  attrs: {
                                    content:
                                      _vm.$t("pc_ote_lbl_excellentrate") +
                                      "=" +
                                      _vm.$t("pc_ote_lbl_excellentpersons") +
                                      "/" +
                                      _vm.$t("pc_ote_lbl_attendcount"),
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("yxt-svg", {
                                    staticClass: "ml4 color-gray-7 hand",
                                    attrs: {
                                      "icon-class": "question-cirlce-o",
                                      width: "14px",
                                      height: "15px",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm.scoreInfo.excellenceScore > 0
                          ? _c(
                              "yxt-row",
                              {},
                              [
                                !_vm.isLoading
                                  ? _c("OteGuage", {
                                      attrs: {
                                        rate: _vm.baseInfo.excellentRate || 0,
                                        rateName: _vm.$t(
                                          "pc_ote_lbl_excellentrate"
                                        ),
                                        uniqueKey: "2",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.scoreInfo.excellenceScore === 0
                          ? _c(
                              "div",
                              { staticClass: "color-gray-7 text-center mt40" },
                              [
                                _c("yxt-svg", {
                                  staticClass: "v-middle mr4",
                                  attrs: {
                                    "icon-class": "set",
                                    width: "16px",
                                    height: "16px",
                                    "remote-url": _vm.mediaUrl,
                                  },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "font-size-14 ml4 lh20 v-mid",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("pc_ote_msg_noexcellentscoreset")
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass:
            "yxtbiz-arrange-statistics__row yxtbiz-arrange-statistics__block",
        },
        [
          _c("div", [
            _c("span", { staticClass: "font-size-16 lh22 font-bold" }, [
              _vm._v(_vm._s(_vm.$t("pc_ote_lbl_scoreanalysis"))),
            ]),
          ]),
          _c("div", { staticClass: "yxtbiz-arrange-statistics__content-row" }, [
            _c(
              "div",
              { staticClass: "yxtbiz-arrange-statistics__content" },
              [
                _c("yxt-svg", {
                  attrs: {
                    "remote-url": _vm.mediaUrl,
                    "icon-class": "analysis-score-all",
                    width: "48px",
                    height: "48px",
                  },
                }),
                _c(
                  "span",
                  { staticClass: "font-size-12 lh20 color-gray-8 mt8" },
                  [_vm._v(_vm._s(_vm.$t("pc_ote_lbl_exampapertotalscore")))]
                ),
                _c("h3", { staticClass: "font-size-24 lh32 mt4 mb0" }, [
                  _vm._v(_vm._s(_vm.scoreInfo.totalScore)),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "yxtbiz-arrange-statistics__content" },
              [
                _c("yxt-svg", {
                  attrs: {
                    "remote-url": _vm.mediaUrl,
                    "icon-class": "analysis-score-pass",
                    width: "48px",
                    height: "48px",
                  },
                }),
                _c(
                  "span",
                  { staticClass: "font-size-12 lh20 color-gray-8 mt8" },
                  [_vm._v(_vm._s(_vm.$t("pc_ote_lbl_passscore")))]
                ),
                _c("h3", { staticClass: "font-size-24 lh32 mt4 mb0" }, [
                  _vm._v(_vm._s(_vm.scoreInfo.passScore)),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "yxtbiz-arrange-statistics__content" },
              [
                _c("yxt-svg", {
                  attrs: {
                    "remote-url": _vm.mediaUrl,
                    "icon-class": "analysis-score-great",
                    width: "48px",
                    height: "48px",
                  },
                }),
                _c(
                  "span",
                  { staticClass: "font-size-12 lh20 color-gray-8 mt8" },
                  [_vm._v(_vm._s(_vm.$t("pc_ote_lbl_excellentscore")))]
                ),
                _vm.scoreInfo.excellenceScore > 0
                  ? _c("h3", { staticClass: "font-size-24 lh32 mt4 mb0" }, [
                      _vm._v(_vm._s(_vm.scoreInfo.excellenceScore)),
                    ])
                  : _c("h3", { staticClass: "font-size-24 lh32 mt4 mb0" }, [
                      _vm._v("--"),
                    ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "yxtbiz-arrange-statistics__content" },
              [
                _c("yxt-svg", {
                  attrs: {
                    "remote-url": _vm.mediaUrl,
                    "icon-class": "analysis-score-max",
                    width: "48px",
                    height: "48px",
                  },
                }),
                _c(
                  "span",
                  { staticClass: "font-size-12 lh20 color-gray-8 mt8" },
                  [_vm._v(_vm._s(_vm.$t("pc_ote_lbl_highestscore")))]
                ),
                _vm.scoreInfo.highestScoreFullname
                  ? _c(
                      "yxt-tooltip",
                      {
                        attrs: {
                          content:
                            "" +
                            _vm.scoreInfo.highestScoreFullname +
                            (_vm.scoreInfo.highestScoreUserName
                              ? "（" + _vm.scoreInfo.highestScoreUserName + "）"
                              : ""),
                          placement: "top",
                        },
                      },
                      [
                        _c("h3", { staticClass: "font-size-24 lh32 mt4 mb0" }, [
                          _vm._v(
                            _vm._s(
                              parseFloat(_vm.scoreInfo.highestScore.toFixed(2))
                            )
                          ),
                        ]),
                      ]
                    )
                  : _c("h3", { staticClass: "font-size-24 lh32 mt4 mb0" }, [
                      _vm._v("--"),
                    ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "yxtbiz-arrange-statistics__content" },
              [
                _c("yxt-svg", {
                  attrs: {
                    "remote-url": _vm.mediaUrl,
                    "icon-class": "analysis-score-min",
                    width: "48px",
                    height: "48px",
                  },
                }),
                _c(
                  "span",
                  { staticClass: "font-size-12 lh20 color-gray-8 mt8" },
                  [_vm._v(_vm._s(_vm.$t("pc_ote_lbl_lowestscore")))]
                ),
                _vm.scoreInfo.minimumScoreFullname
                  ? _c(
                      "yxt-tooltip",
                      {
                        attrs: {
                          content:
                            "" +
                            _vm.scoreInfo.minimumScoreFullname +
                            (_vm.scoreInfo.minimumScoreUserName
                              ? "（" + _vm.scoreInfo.minimumScoreUserName + "）"
                              : ""),
                          placement: "top",
                        },
                      },
                      [
                        _c("h3", { staticClass: "font-size-24 lh32 mt4 mb0" }, [
                          _vm._v(
                            _vm._s(
                              parseFloat(_vm.scoreInfo.minimumScore.toFixed(2))
                            )
                          ),
                        ]),
                      ]
                    )
                  : _c("h3", { staticClass: "font-size-24 lh32 mt4 mb0" }, [
                      _vm._v("--"),
                    ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "yxtbiz-arrange-statistics__content" },
              [
                _c("yxt-svg", {
                  attrs: {
                    "remote-url": _vm.mediaUrl,
                    "icon-class": "analysis-score-avg",
                    width: "48px",
                    height: "48px",
                  },
                }),
                _c(
                  "span",
                  { staticClass: "font-size-12 lh20 color-gray-8 mt8" },
                  [_vm._v(_vm._s(_vm.$t("pc_ote_lbl_avgscore")))]
                ),
                _vm.scoreInfo.averageScore > 0
                  ? _c("h3", { staticClass: "font-size-24 lh32 mt4 mb0" }, [
                      _vm._v(
                        _vm._s(
                          parseFloat(_vm.scoreInfo.averageScore.toFixed(2))
                        )
                      ),
                    ])
                  : _c("h3", { staticClass: "font-size-24 lh32 mt4 mb0" }, [
                      _vm._v(_vm._s(_vm.scoreInfo.averageScore)),
                    ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "yxtbiz-arrange-statistics__content" },
              [
                _c("yxt-svg", {
                  attrs: {
                    "remote-url": _vm.mediaUrl,
                    "icon-class": "analysis-time-cost",
                    width: "48px",
                    height: "48px",
                  },
                }),
                _c(
                  "span",
                  { staticClass: "font-size-12 lh20 color-gray-8 mt8" },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("pc_ote_lbl_avgtimeconsuming")) + "(min)"
                    ),
                  ]
                ),
                _vm.scoreInfo.averageTime > 0
                  ? _c("h3", { staticClass: "font-size-24 lh32 mt4 mb0" }, [
                      _vm._v(
                        _vm._s(parseFloat(_vm.scoreInfo.averageTime.toFixed(1)))
                      ),
                    ])
                  : _c("h3", { staticClass: "font-size-24 lh32 mt4 mb0" }, [
                      _vm._v(_vm._s(_vm.scoreInfo.averageTime)),
                    ]),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "yxtbiz-arrange-statistics__row yxtbiz-arrange-statistics__block",
        },
        [
          _vm.isLoopExamAll
            ? [
                _c(
                  "div",
                  { staticClass: "yxtbiz-arrange-statistics__block-bar" },
                  [
                    _c("span", { staticClass: "font-size-16 lh24 font-bold" }, [
                      _vm._v(_vm._s(_vm.$t("pc_ote_lbl_accuracyofbatch"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "yxtbiz-arrange-statistics__table-tab" },
                      [
                        _c(
                          "yxt-radio-group",
                          {
                            staticClass: "radio-active-border",
                            on: { change: _vm.changeSource },
                            model: {
                              value: _vm.barSource,
                              callback: function ($$v) {
                                _vm.barSource = $$v
                              },
                              expression: "barSource",
                            },
                          },
                          _vm._l(_vm.sourceList, function (item, index) {
                            return _c(
                              "yxt-radio-button",
                              { key: index, attrs: { label: item.value } },
                              [_vm._v(_vm._s(item.label))]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "pb16 mt12" },
                  [
                    _c("BarChart", {
                      staticClass: "pt20",
                      attrs: {
                        chartType: _vm.ChartType.line,
                        dataType: _vm.chartDataType,
                        dataList: _vm.graphData,
                      },
                    }),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "div",
                  { staticClass: "yxtbiz-arrange-statistics__block-bar" },
                  [
                    _c("span", { staticClass: "font-size-16 lh24 font-bold" }, [
                      _vm._v(_vm._s(_vm.$t("pc_ote_lbl_accuracysta"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "yxtbiz-arrange-statistics__table-tab" },
                      [
                        _c(
                          "yxt-radio-group",
                          {
                            staticClass: "radio-active-border",
                            on: { change: _vm.changeSource },
                            model: {
                              value: _vm.barSource,
                              callback: function ($$v) {
                                _vm.barSource = $$v
                              },
                              expression: "barSource",
                            },
                          },
                          _vm._l(_vm.sourceList, function (item, index) {
                            return _c(
                              "yxt-radio-button",
                              { key: index, attrs: { label: item.value } },
                              [_vm._v(_vm._s(item.label))]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "pb16 mt12" },
                  [
                    _c("BarChart", {
                      staticClass: "pt20",
                      attrs: {
                        chartType: _vm.ChartType.bar,
                        dataType: _vm.ChartDataType.percent,
                        dataList: _vm.histoData,
                      },
                    }),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }